import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Login Page Component
 */
const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    if (!email || !password) {
      setError('Please fill in all fields');
      return;
    }

    const result = login(email, password);
    if (result.success) {
      navigate('/profile');
    } else {
      setError('Login failed. Please check your credentials.');
    }
  };

  return (
    <div className="container" style={{ paddingTop: '50px', maxWidth: '500px' }}>
      <h1 style={{ fontSize: '36px', marginBottom: '30px', textAlign: 'center' }}>
        🔐 Login
      </h1>
      <div className="card">
        <form onSubmit={handleSubmit}>
          {error && (
            <div style={{ 
              background: 'var(--highlight-color)', 
              padding: '10px', 
              borderRadius: '5px', 
              marginBottom: '20px',
              textAlign: 'center'
            }}>
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
            />
          </div>

          <button type="submit" className="btn btn-primary" style={{ width: '100%', marginBottom: '20px' }}>
            Login
          </button>

          <p style={{ textAlign: 'center', color: 'var(--text-dark)' }}>
            Don't have an account? <Link to="/register" style={{ color: 'var(--highlight-color)' }}>Register here</Link>
          </p>
        </form>
      </div>

      <div className="card" style={{ marginTop: '20px', textAlign: 'center', background: 'var(--card-hover)' }}>
        <p style={{ color: 'var(--text-dark)', marginBottom: '10px' }}>
          <strong>Demo Credentials:</strong>
        </p>
        <p style={{ color: 'var(--text-dark)', fontSize: '14px' }}>
          Email: demo@rocketverse.com<br />
          Password: any password works (demo mode)
        </p>
      </div>
    </div>
  );
};

export default Login;
